
import { Component, Vue } from "vue-property-decorator";
import ComplianceProfile from "@/modules/Compliance/Profile/ComplianceProfile.vue";

const TYPE_EXPERT_COMPANIES_PROFILE = "expertCompaniesProfile";

@Component({
  components: { ComplianceProfile },
})
export default class CompanyDetails extends Vue {
  type = TYPE_EXPERT_COMPANIES_PROFILE;
}
